<template>
  <div class="flex w-full flex-col gap-2">
    <label :for="$attrs['input-id'] as string" :class="{ 'cursor-pointer': !$attrs.disabled }">{{ label }}</label>
    <Password v-bind="$attrs" toggle-mask input-class="w-full" />
  </div>
</template>

<script setup lang="ts">
defineOptions({
  inheritAttrs: false
});

defineProps<{
  label: string;
}>();
</script>
